const guatemalaExpress = {
    title: 'Guatemala Express',
    shortDescripction: 'Este circuito le permite conocer los principales destinos turísticos de Guatemala, visitaremos: La ciudad colonia de Antigua Guatemala, La Belleza Natural del Lago de Atitlán, y el Mercado Típico de Chichicastenango, la cuna de la civilización maya de la actualidad además vivamos una aventura extrema en el volcán de Pacaya.',
};

export const circuits = {
    guatemalaExpress,
};